<template>
  <ul class="box">
    <li class="bg01" :class="[cur === 0 && 'cur']" @touchstart="touchstart" @touchmove="touchmove" @touchend="touchend($event, 0)">
    </li>
    <li class="bg02" :class="[cur === 1 && 'cur']" @touchstart="touchstart" @touchmove="touchmove" @touchend="touchend($event, 1)">
      <a-button type="primary" class="use-now" @click="toLogin">立即使用</a-button>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Guide",
  data() {
    return {
      cur: 0,
      touchInfo: {
        startX: 0,
        endX: 0,
      },
    }
  },
  mounted(){
    localStorage.setItem('showGuide','true');
  },
  methods: {
    touchstart(e) {
      this.touchInfo.startX = e.touches[0].clientX
    },
    touchmove(e) { },
    touchend(e, index) {
      this.touchInfo.endX = e.changedTouches[0].clientX
      const moveX = this.touchInfo.endX - this.touchInfo.startX
      this.touchInfo = {
        startX: 0,
        endX: 0,
      }
      if (moveX >= 100) {
        this.cur = index === 0 ? 1 : 0
      }
      if (moveX <= -100) {
        this.cur = index === 1 ? 0 : 1
      }
    },
    toLogin() {
      this.$router.push({ path: '/user/login' })
    }
  }
}
</script>

<style scoped lang="less">
.box {
  margin: 0;
  padding: 0;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;

  // ::-webkit-scrollbar {
  //   display: none;
  //   width: 80px;
  //   height: 80px;
  // }


  li {
    width: 100%;
    height: 100%;
    list-style: none;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    opacity: 0;
    animation: hide .2s;
    animation-fill-mode: forwards;
  }

  .bg01{
    background: #0b1c2b url(~@/assets/guide01.png) center top / cover no-repeat; 
  }
  .bg02{
    background: #0b1c2b url(~@/assets/guide02.png) center top / cover no-repeat; 
  }

  .cur {
    animation: show .2s;
    animation-fill-mode: forwards;
    z-index: 1;
  }

  .use-now {
    position: absolute;
    left: 50%;
    bottom: 64px;
    transform: translateX(-50%);
    cursor: pointer;
    width: 308px;
    height: 75px;
    background: linear-gradient( 137deg, #3FAFFF 0%, #8000FF 100%);
    border-radius: 86px 86px 86px 86px;
    font-weight: 600;
    font-size: 24px;
    color: #FFFFFF;
  }

  @keyframes show {

    0% {
      opacity: 0;
    }

    25% {
      opacity: 0.25;
    }

    50% {
      opacity: 0.5;
    }

    75% {
      opacity: 0.75;
    }

    100% {
      opacity: 1;
    }
  }

  @keyframes hide {

    0% {
      opacity: 1;
    }

    25% {
      opacity: 0.75;
    }

    50% {
      opacity: 0.5;
    }

    75% {
      opacity: 0.25;
    }

    100% {
      opacity: 0;

    }
  }
}
</style>